import React from 'react';
import { useSelector } from 'react-redux';
import i18n from '../../../i18n';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useAction } from 'core/store/store';

import {
    makeDeliveryServicePrepareExternalDelivery,
    makeDeliveryServiceSubmitDeliveryDetailsFormAction,
    makeDeliveryServiceUpdateDeliveryPlanListAction,
} from 'state/deliveryService/actions';
import { deliveryServiceFormTabSelector } from 'state/deliveryService/selector';
import { DeliveryServiceFormTab } from 'state/deliveryService/types';

import { DeliveryWeightForm } from 'forms/DeliveryWeightForm/DeliveryWeightForm';
import { DeliveryPlanForm } from 'forms/DeliveryPlanForm/DeliveryPlanForm';
import { DeliveryDetailsForm } from 'forms/DeliveryDetailsForm/DeliveryDetailsForm';
import { ErrorBoundary } from 'components/ErrorBoundary';

import { Dialog } from 'components/Dialog/Dialog';

const useStyles = makeStyles({
    container: {
        width: '100%',
    },
});

export const OrderDeliveryDetailsDialog = () => {
    const { t } = i18n.useTranslation();
    const action = useAction();
    const classes = useStyles();
    const tab = useSelector(deliveryServiceFormTabSelector);
    return (
        <ErrorBoundary>
            <Dialog fullHeight={true} title={t('orders:deliveryCard.title')} hideCloseButton={true}>
                <Box className={classes.container} m={2}>
                    {tab === DeliveryServiceFormTab.WEIGHT && (
                        <DeliveryWeightForm
                            onSubmit={data => {
                                action(makeDeliveryServiceUpdateDeliveryPlanListAction, data.weight);
                            }}
                        />
                    )}
                    {tab === DeliveryServiceFormTab.PLAN && (
                        <DeliveryPlanForm
                            onSubmit={data => {
                                action(makeDeliveryServicePrepareExternalDelivery, data.plan);
                            }}
                        />
                    )}
                    {tab === DeliveryServiceFormTab.DETAILS && (
                        <DeliveryDetailsForm
                            onSubmit={data => {
                                action(makeDeliveryServiceSubmitDeliveryDetailsFormAction, data);
                            }}
                        />
                    )}
                </Box>
            </Dialog>
        </ErrorBoundary>
    );
};
